module.exports = __webpack_public_path__ + "img/staff-photo-main.8409920.png";